const DICTIONARY_INITIAL_SHOW_COUNT = 6;
const DICTIONARY_DETAIL_PARAMS = 'nedir';
const DICTIONARY_TEXT = {
  SHOW_ALL : 'Daha Fazla Göster',
  HEPSIBURADA: 'hepsiburada ',
  DICTIONARY: 'sözlük',
  DETAIL: 'Detaylar',
  READ_MORE: 'Devamını Oku',
  READ_LESS: 'Devamını Gizle',
  CATEGORY_MOST_KEYWORD: 'Kategorisinde En Çok Merak Edilenler',
  THIS_CATEGORY_MOST_KEYWORD: 'Bu Kategoride En Çok Merak Edilenler',
  DETAIL_TITLE_SUFFIX: 'Nedir?',
}

export {
  DICTIONARY_INITIAL_SHOW_COUNT,
  DICTIONARY_DETAIL_PARAMS,
  DICTIONARY_TEXT,
}
